/**
 * Biddle brand colours — single source of truth for hex values used in JS
 * (map pins, canvas, etc.). Prefer Tailwind tokens (`bg-biddle-blue`, …)
 * in CSS/classNames; keep those tokens in sync with these constants.
 */
export const BIDDLE_BLUE = '#098ce6'
export const BIDDLE_BLUE_DARK = '#0776c4'
export const BIDDLE_NAVY = '#0b1f3a'
